module.exports = __webpack_public_path__ + "img/fwh.4e07e175.png";